import { render, staticRenderFns } from "./Talent-add.vue?vue&type=template&id=084a491e&scoped=true&"
import script from "./Talent-add.vue?vue&type=script&lang=js&"
export * from "./Talent-add.vue?vue&type=script&lang=js&"
import style0 from "./Talent-add.vue?vue&type=style&index=0&id=084a491e&lang=less&scoped=true&"
import style1 from "./assets/index.less?vue&type=style&index=1&id=084a491e&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084a491e",
  null
  
)

export default component.exports